<template>
  <div class="mytable" v-tooltip="{
                    global: true,
                    theme: {
                        'background-color':'#f5c7c7',
                        'color':'#454242',
                        'font-size':'1rem'
                    },
                }">

    <div class=" head_info_rotate" v-if="!closed && ordMin">Cu</div>
    <div class=" head_info_rotate" v-if="!closed && !ordMin">Currency</div>

    <div v-show="currency_info" class="table">
      <div class="col" style="width: 25px; margin: 0; padding: 0;text-align: center">
        <div class="rotate" :class="{close:closed}" @click="hidden"><span> </span></div>
      </div>
      <div class="col" v-if="closed">
        <div class="head_closed"> Currency
          <div class="account_info_small_top">{{ currency_info.length }}</div>
        </div>
      </div>
      <div v-else class="cel">
        <div class="table" style="width: 33%">
          <div class="thead">
            <div class="tr">
              <div class="th t_left">Ticker</div>
              <div class="th">Shares</div>
               <div class="th">Price</div>
             </div>
          </div>
          <div class="tbody">
            <div class="tr" v-for="(item, i) in currency_info" :key="i">
              <div class="td t_left">{{ item.Ticker }}</div>
              <div class="td">{{ item.Shares }}</div>
              <div class="td">{{ getValue(instruments[item.Ticker], 'Last') }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ref, watch} from "vue"
import {getInstruments} from "@/store/global";


export default {
  name: "CurrencyTable",
  props: ["positions"],
  setup(props) {
    const positions_info = ref(props.positions);
    const currency_info=ref({})


    const instruments = getInstruments()
    const getValue = (obj, param) => {
      if (typeof (obj) != "undefined" && typeof (obj[param]) != "undefined") {
        return obj[param]
      }
      return 0
    }
    const ordMin = ref(true)
    if (positions_info.value.length > 1) {
      ordMin.value = false;
    }
    const getCurrencyInfo=()=>{

      currency_info.value={}
      let res=positions_info.value.filter(item=>item.Ticker.length<5);
      currency_info.value=res
    }
    watch(() =>props.positions, () => {
      currency_info.value = props.positions.filter(item => item.Ticker.length < 5)
     // console.log("position change")
     // console.log(props.positions)
      //getCurrencyInfo()
        if (props.positions.length > 1) {
          ordMin.value = false
        } else {
          ordMin.value = true
        }


     //
    //  console.log(nV.value)
    },{deep: true})

    const getStringTime = (val) => {
      if (val < 2613553314) {
        let ts = new Date(val * 1000);
        return (
            pad(ts.getHours()) +
            ":" +
            pad(ts.getMinutes()) +
            ":" +
            pad(ts.getSeconds())
        );
      }
      return ""
    }
    const getStringDate = (val) => {
      if (val < 2613553314) {
        let ts = new Date(val * 1000);
        return (
            pad(ts.getDate()) +
            "/" +
            pad(ts.getMonth() + 1) +
            "/" +
            ts.getFullYear()
        );
      }
      return ""
    }
    const pad = (n) => {
      return n < 10 ? "0" + n : n;
    }
    const isset = (obj, param) => {
      if (typeof (obj) != "undefined" && obj.length > 0 && typeof (obj[param]) != "undefined" && obj[param].length > 0) {
        return true
      }
      return false
    }
    const hidden = () => {
      if (closed.value == false) {
        if (positions_info.value.length != 0) {
          closed.value = true
        }
        return
      } else {
        closed.value = false
      }
    }
    const closed = ref(false)
    if(currency_info.value.length>0){
      closed.value=false
    }
    getCurrencyInfo()
    return {
      currency_info,
      getValue,
      getStringTime,
      getStringDate,
      isset,
      instruments,
      closed,
      hidden,
      ordMin
    }
  }
}
</script>
/*
table    { display: table }
tr       { display: table-row }
thead    { display: table-header-group }
tbody    { display: table-row-group }
tfoot    { display: table-footer-group }
col      { display: table-column }
colgroup { display: table-column-group }
td, th   { display: table-cell }
caption  { display: table-caption }
*/
<style scoped>
div.rotate.close {
 /* background-color: white;
  border: none;
  color: white;
  display: inline-block;
  position: relative;
  margin: 0;
  padding: 0;
  width: 14px;
  height: 14px;
  cursor: pointer;
  transition: background 0s 0.3s;
  transform: rotate(45deg);*/
}

div.rotate {
  background-color: white;
  border: none;
  color: white;
  display: inline-block;
  position: relative;
  margin: 0;
  padding: 0;
  width: 14px;
  height: 14px;
  cursor: pointer;
  transition: background 0s 0.3s;
}

div.rotate:focus {
  outline: none;
  border: none;
  background-color: white;
}

div.rotate span {
  position: absolute;
  display: block;
  left: 0px;
  bottom: 5px;
  width: 100%;
  height: 2px;
  background-color: #000000;
  content: "";
}

div.rotate span::before {
  position: absolute;
  display: block;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #000000;
  content: "";
  transform: rotate(90deg);
}
div.rotate.close span {
  position: absolute;
  display: block;
  left: 0px;
  bottom: 5px;
  width: 100%;
  height: 2px;
  background-color: #000000;
  content: "";
  transform: rotate(45deg);
}

div.rotate.close span::before {
  position: absolute;
  display: block;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #000000;
  content: "";
 /* transform: rotate(135deg);*/
}

.t_left {
  text-align: left !important;
}

.col {

  text-align: center;
}

.table {
  margin-top: 4px;
  width: 100%;
  display: table;
  table-layout: fixed;
  /*min-height: 80px;*/
}

.vmiddle {
  vertical-align: middle;
}

.thead {

  font-family: Proxima Nova Condensed;
  font-size: 14px;
  font-style: normal;
  font-weight: normal;
  line-height: 17px;
  color: #777777;
  width: 100%;
  padding-bottom: 4px;
  height: 17px;
  display: table-header-group;
}

.thead .tr .th {
  border-bottom: 1px solid #e82862;
  text-align: center;
}

.tr {
  display: table-row;
  width: 100%;
}

.cel, .col, .td, .th {
  display: table-cell;
  width: 100%;
  padding: 2px 0px;
}

.tbody .tr .td {
  overflow: hidden;
  white-space: nowrap;
  text-align: center;
}

.tbody {
  display: table-row-group;
}

.tbody .tr:nth-child(odd) {
  background-color: #f7f7f7;
}


.head_info_rotate {
  position: absolute;
  left: -17px;
  top: 46px;
  padding: 0px;
  margin: 0px;
  -webkit-transform: rotate(-90deg);
  transform: rotate(-90deg);
  font-family: Proxima Nova Condensed;
  font-size: 9px;
  font-style: normal;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: left;
  color: #222222;
  width: 60px;
  text-align: right;
}

.head_closed {
  font-family: Proxima Nova Condensed;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: left;
  color: #222222;
  border-bottom: 1px solid #e82862;
  padding-bottom: 1px;
}

.account_info_small_top {
  margin-left: 3px;
  font-family: Proxima Nova Condensed;
  font-size: 10px;
  font-style: normal;
  font-weight: normal;
  line-height: 12px;
  color: #777777;
  position: absolute;
  display: inline-block;
}

.mytable {
  width: 100%;
  padding-bottom: 5px;
  position: relative;
}

.mytable_row {
  height: 20px;
}

.col .mytable_row:nth-child(even) {
  background-color: #f7f7f7;
}

</style>